module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-mobile@2x-130b884439c261ab084cd7f9e67cff9a.jpg";